module.exports = __webpack_public_path__ + "img/submit.db9b0132.png";